import config from "../../../config/domain";
import { apiService } from "../apiServices";
import servicesList from "../serviceList";

export const AGetStageCompletionStatus = (
  callback: CallableFunction,
  applicationid: string
) => {
  apiService(
    {
      url: "StageDetail/GetStatus",
      body: {
        ApplicationId: applicationid,
        esigndocumenttype: 0
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getStageCompletionStatus,
    },
    callback
  );

  // apiService(
  //     {
  //         url: 'eco/get-stage-completion-status',
  //         body: {
  //             "applicationid": applicationid
  //         },
  //         method: "POST",
  //     },
  //     callback
  // );
};
export const AUpdateStageCompletionStatus = (
  callback: CallableFunction,
  reaObj?: any
) => {
  apiService(
    {
      url: "StageDetail/Update",
      body: {
        applicationId: reaObj?.applicationId,
        accountCagtegory: reaObj?.accountCagtegory,
        stageOrderId: reaObj?.stageOrderId,
        UserId: reaObj?.UserId ? reaObj?.UserId : "0",
        rmassisted: reaObj?.rmassisted ? reaObj?.rmassisted : false
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getStageCompletionStatus,
    },
    callback
  );

  // apiService(
  //     {
  //         url: 'eco/get-stage-completion-status',
  //         body: {
  //             "applicationid": applicationid
  //         },
  //         method: "POST",
  //     },
  //     callback
  // );
};
export const AGetCacheData = (
  callback: CallableFunction,
  dataObj: {
    uniqueID: string;
    key: string;
  }
) => {
  apiService(
    {
      url: "Cache/Get",
      body: dataObj,
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getCacheData,
    },
    callback
  );
};
